import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'


export default function Manage_team() {
  const [membretype, setMembertype] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    let memtype = localStorage.getItem('membership_type');
    if (memtype === 'free') {
      setMembertype(true);
    }
    let proname = localStorage.getItem('proname');

    let proid = localStorage.getItem('projid');
    console.log(proname + ' : ' + proid);
    $('#pro_name').text('Project Name : ' + proname);
    console.log(proid);

    const handleMessage = (event) => {
      if (event.data?.action === "redirect" && event.data?.url) {
        window.location.href = `/${event.data.url}`;
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [])

  function setIframeHeightcrd() {
    var iframe = document.getElementById('report_iframe');
    var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    var iframeContentHeight = (iframeDocument.body.scrollHeight);
    iframe.style.height = iframeContentHeight + 'px';
  }

  function SaveTMToProj() {
    $('#add_memdber_form').css('display', 'block');
  }

  function closemempop() {
    $('#add_memdber_form').css('display', 'none');
  }
  function savemember() {
    var mem_first_name = $('#memberfname').val();
    var mem_last_name = $('#memberlname').val();
    var mememail = $('#memberemail').val();
    if (mem_first_name === '') {
      showAlert('Please insert the member first name.');
    } else if (mem_last_name === '') {
      showAlert('Please insert the member last name.');
    } else if (mememail === '') {
      showAlert('Please insert the member email.');
    } else {
      var company_id = localStorage.getItem('mem_company_id');
      var comname = localStorage.getItem('mem_company_name');
      var memberimg = 'profile_imgs/no-image-icon-32.jpg';
      var companyimg = localStorage.getItem('companylogo');

      var obj = {
        mem_account_status: 'not_complete',
        mem_email: mememail,
        password: '',
        country: '',
        expertise: '',
        mem_skills: '',
        mem_com_id: company_id,
        mem_role: 'Member',
        company_name: comname,
        fname: mem_first_name,
        lname: mem_last_name,
        activation: 'no',
        memberimg: memberimg,
        companyimg: companyimg

      }
      console.log(obj);
      $.ajax({
        type: 'POST',
        url: 'memberListingsignup.php',
        data: obj,
        cache: false,
        success: function (result) {
          console.log(result);
          if (result != 'Mail Exist') {
            // navigate('/redirect_manage_tool');
            sendEmailToUser(result, mememail);
          } else {
            showAlert(mememail + ' the EMAIL you enter already in use.')
          }
        },
      });
    }

  }

  function sendEmailToUser(mid, memail) {
    var memid = mid;
    var mememail = memail;
    var memid = mid;
    var comname = localStorage.getItem('mem_company_name');
    var companyemail = localStorage.getItem('useremail');

    var obj = {
      memid: memid,
      mememail: mememail,
      comname: comname,
      companyemail: companyemail,
    }
    console.log(obj)
    $.ajax({
      type: 'POST',
      url: 'addmember_user_email.php',
      data: obj,
      cache: false,
      success: function (result) {
        console.log("Response: ", result);
        if (result !== 'fail') {
          navigate('/redirect_manage_tool');
        } else {
          alert('Cannot create account. Please try again.');
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", status, error);
        console.error("Response Text:", xhr.responseText);
        alert('Server error occurred. Check console for details.');
      }
    });
  }
  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <section className='vl_dsh_bodypart_section'>
          <div className='create_heading'>
            <p id="pro_name"></p>
            <h2>Create Team For Your Project</h2>
          </div>
          <div className='vl_dsh_one_row mt-50'>
            <div className='vl_dsh_one_full'>
              <div className='vl_dsh_header_bar'>
                <h2>Choose members for this project</h2>
                <div className='vl_dsh_addbtnholder'>

                </div>
              </div>
            </div>
            <div className='vl_dsh_one_full'>
              <iframe id="report_iframe" className="report_iframe" src="listTeamMembers.html" title="Credit report from EFX" ></iframe>
            </div>
          </div>
        </section>
      </div>
      <div className='vl_dsh_popup' id="add_memdber_form">
        <div className='vl_dsh_pop_content_fixwidth'>
          <div className='fullwidth pull_left'>
            <button className='vl_dsh_pop_content_close' onClick={closemempop}>+</button>
          </div>
          <div className='fullwidth pull_left mt-20'>
            <div className='formarea'>
              <div className='formfieldholder'>
                <label>Member First Name</label>
                <input type="text" id="memberfname" />
              </div>
              <div className='formfieldholder'>
                <label>Member Last Name</label>
                <input type="text" id="memberlname" />
              </div>
              <div className='formfieldholder'>
                <label>Member Emnail</label>
                <input type="email" id="memberemail" />
              </div>
              <div className='formfieldholder mt-15 text_right'>
                <button onClick={savemember}>Add Member</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
      {membretype && (
        <div className='vl_dsh_popup activebillpop'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>

            <div className='contentarea'>
              <p>Please upgrade your membership to access this page</p>
            </div>
            <div className='alert_btns'>
              <button onClick={() => window.history.back()}>Back</button>
            </div>

          </div>
        </div>
      )}
    </div>
  )
}
